// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_card__-RxYq {
  margin: 1.2rem 0;
  width: 100%;
  height: 280px;
  display: flex;
  flex-direction: row;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  overflow: hidden;

  .card_header__LrqlC {
    display: flex;
    gap: 10px;

    & img {
      width: auto;
      height: auto;
    }

    & h1 {
      padding-top: 6px;
      margin: 0;
      font-family: Instrument Sans;
      font-size: 0.87rem;
      font-weight: 500;
    }
  }

  & h2 {
    font-family: Inter;
    font-size: 0.87rem;
    font-weight: 600;
  }

  & p {
    font-family: Inter;
    font-size: 0.8rem;
    font-weight: 400;
  }

  & a {
    color: #62677a;
    font-family: Inter;
    font-size: 0.75rem;
    font-weight: 400;
    text-decoration: none;
  }
}

.card_left__UJplm {
  flex: 1 1;
  padding: 20px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.card_title__P3GMd {
  font-size: 1.25rem;
  font-weight: bold;
  color: #333;
}

.card_subtitle__ofuuh {
  font-size: 1rem;
  font-weight: 500;
  color: #555;
  margin: 5px 0;
}

.card_description__zmCAn {
  font-size: 0.9rem;
  color: #777;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ScreenCard/card.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;;EAEhB;IACE,aAAa;IACb,SAAS;;IAET;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,gBAAgB;MAChB,SAAS;MACT,4BAA4B;MAC5B,kBAAkB;MAClB,gBAAgB;IAClB;EACF;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;EACvB;AACF;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb","sourcesContent":[".card {\n  margin: 1.2rem 0;\n  width: 100%;\n  height: 280px;\n  display: flex;\n  flex-direction: row;\n  cursor: pointer;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  border-radius: 5px;\n  overflow: hidden;\n\n  .header {\n    display: flex;\n    gap: 10px;\n\n    & img {\n      width: auto;\n      height: auto;\n    }\n\n    & h1 {\n      padding-top: 6px;\n      margin: 0;\n      font-family: Instrument Sans;\n      font-size: 0.87rem;\n      font-weight: 500;\n    }\n  }\n\n  & h2 {\n    font-family: Inter;\n    font-size: 0.87rem;\n    font-weight: 600;\n  }\n\n  & p {\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-weight: 400;\n  }\n\n  & a {\n    color: #62677a;\n    font-family: Inter;\n    font-size: 0.75rem;\n    font-weight: 400;\n    text-decoration: none;\n  }\n}\n\n.left {\n  flex: 1;\n  padding: 20px;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.title {\n  font-size: 1.25rem;\n  font-weight: bold;\n  color: #333;\n}\n\n.subtitle {\n  font-size: 1rem;\n  font-weight: 500;\n  color: #555;\n  margin: 5px 0;\n}\n\n.description {\n  font-size: 0.9rem;\n  color: #777;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `card_card__-RxYq`,
	"header": `card_header__LrqlC`,
	"left": `card_left__UJplm`,
	"title": `card_title__P3GMd`,
	"subtitle": `card_subtitle__ofuuh`,
	"description": `card_description__zmCAn`
};
export default ___CSS_LOADER_EXPORT___;
